<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'LANGUAGES', url: ['../list'] },
    { label: isUpdateMode ? 'UPDATE_LANGUAGE' : 'CREATE_LANGUAGE' }
  ]"
></breadcrumbs>

<page-header
  [title]="isUpdateMode ? 'UPDATE_LANGUAGE' : 'CREATE_LANGUAGE'"
></page-header>

<card>
  <form class="form" (submit)="onSubmit()" [formGroup]="form">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="COUNTRY">{{
        'COUNTRY' | translate
      }}</label>
      <ng-select
        [items]="countries"
        name="name"
        [multiple]="false"
        [closeOnSelect]="true"
        formControlName="country"
        bindLabel="name"
        class="is-small"
      >
      </ng-select>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="IS_DEFAULT">{{
        'IS_DEFAULT' | translate
      }}</label>
      <div class="control">
        <chip
          [checked]="isDefaultControll.value"
          (onChange)="check($event, isDefaultControll)"
        >
          <span
            [translationEditableDirective]="
              (isDefaultControll.value ? 'ENABLED' : 'DISABLED') | translate
            "
          >
            {{ (isDefaultControll.value ? 'ENABLED' : 'DISABLED') | translate }}
          </span>
        </chip>
      </div>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="AVAILABLE">{{
        'AVAILABLE' | translate
      }}</label>
      <div class="control">
        <chip
          [checked]="availableControll.value"
          (onChange)="check($event, availableControll)"
        >
          <span
            [translationEditableDirective]="
              (availableControll.value ? 'ENABLED' : 'DISABLED') | translate
            "
          >
            {{ (availableControll.value ? 'ENABLED' : 'DISABLED') | translate }}
          </span>
        </chip>
      </div>
    </div>
  </form>
</card>

<div class="field is-grouped px-3">
  <div class="control">
    <button
      [disabled]="isLoading || form.invalid || form.pristine"
      type="submit"
      class="button is-success"
      translationEditableDirective="SUBMIT"
      (click)="onSubmit()"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['../list']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
    >
      {{ 'CANCEL' | translate }}
    </a>
  </div>
</div>
